import React, { useState } from "react";
import ChatTickets from "./ChatTickets/ChatTickets";
import { otherCategories } from "../enum";

const { EXTERNAL_EMAILS } = otherCategories;
const AgentInboxTickets = () => {
    const [showFilters, toggleFilters] = useState(true);
    const [refreshData, setRefreshData] = useState(0);
    const [ticketData, setTicketData] = useState([]);
    const [selectedTicketHeader, setSelectedTicketHeader] = useState();
    const [showEmail, toggleEmail] = useState(false);
    const [selectedCannedEmail, setSelectedCannedEmail] = useState({});

    const [refetchEmails, toggleRefetchEmails] = useState(false);
    const [emailAction, setEmailAction] = useState("");

    // const userToken = retriveAccessToken();

    const handleRefreshData = () => {
        setRefreshData((prevState) => prevState + 1);
    };

    const reconnectUser = () => {
        // const socketReconnection = reconnectSocket(userToken);
        // setSocketConnection(socketReconnection);
        console.log("Attempted recconnection")
    };

    const handleToggleEmailPreview = (cannedEmail, actionType) => {
        setSelectedTicketHeader(EXTERNAL_EMAILS);
        setSelectedCannedEmail(cannedEmail);
        toggleEmail(true);
        setEmailAction(actionType);
    };

    const handleRemoveEmailPreview = () => {
        setEmailAction();
        setSelectedCannedEmail();
        toggleEmail(false);
    };

    // useEffect(() => {
    //     if (!socket?.connected) {
    //         reconnectUser();
    //     }
    //     // }, [socket, userToken]);
    //     // eslint-disable-next-line
    // }, []);


    return (
        <div className='h-100'>
            <>
                <div
                    className={`flexible__layout ${showFilters ? "active--filters" : ""
                        }`}>
                    <ChatTickets
                        reconnectUser={reconnectUser}
                        refreshData={refreshData}
                        handleRefreshData={handleRefreshData}
                        setTicketData={setTicketData}
                        showFilters={showFilters}
                        toggleFilters={toggleFilters}
                        handleToggleEmailPreview={handleToggleEmailPreview}
                        selectedTicketHeader={selectedTicketHeader}
                        setSelectedTicketHeader={setSelectedTicketHeader}
                        refetchEmails={refetchEmails}
                        ticketData={ticketData}
                        toggleEmailPreview={(status = false) => {
                            toggleEmail(status);
                            // setSelectedCannedEmail();
                        }}
                        handleRemoveEmailPreview={handleRemoveEmailPreview}
                        handleSuccess={() =>
                            toggleRefetchEmails(!refetchEmails)
                        }
                        emailPreviewValue={selectedCannedEmail}
                        emailAction={emailAction}
                        showEmailPreview={showEmail}
                    />
                </div>
            </>
        </div>
    );
};

export default AgentInboxTickets;
